export class InputSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      width: {
        type: '%',
        value: 100
      },
      background: 'none',
      padding: {
        paddingTop: 3,
        paddingBottom: 0,
        paddingLeft: 3,
        paddingRight: 0
      },
      margin: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
      },
      font: {
        fontSize: 12
      },
      height: {
        type: 'px',
        value: 30
      },
      border: {
        borderWidth: 1,
        borderColor: '#c7c7c7',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderStyle: 'solid'
      },
      labelValue: 'Label',
      labelPosition: 'outer',
      label: {
        color: 'black',
        fontSize: 8,
        padding: 4,
        fontWeight: 600
      },
      required: false,
      maxLength: 1000000,
      fieldName: '',
      languages: {},
      selectedLanguage: ''
    };
    Object.assign(this, defaults, overrides);
  }
}
export const InputTypes = {
  settings: {
    required: {
      title: 'Required',
      type: 'Switch'
    },
    fieldName: {
      title: 'Field Name*',
      type: 'Input'
    }
  },
  label: {
    labelValue: {
      title: 'Label Value',
      type: 'InputLanguage'
    },
    labelPosition: {
      title: 'Label Position',
      type: 'LabelPosition',
      customOptions: ['inner', 'outer']
    }
  },
  size: {
    width: {
      title: 'Width',
      type: 'Size'
    },
    height: {
      title: 'Height',
      type: 'Size'
    }
  },
  spacing: {
    padding: {
      title: 'Padding',
      type: 'Padding'
    },
    margin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  styles: {
    background: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    border: {
      title: 'Border',
      type: 'Border'
    }
  }
};